import { checkAllIntegrations } from './methods/check-all-integrations'
import { connectIntegration } from './methods/connect-integration'
import { disconnectIntegration } from './methods/disconnect-integration'
import { handleOAuthResponse } from './methods/handle-oauth-response'

export const integrationService = {
  checkAllIntegrations,
  connectIntegration,
  disconnectIntegration,
  handleOAuthResponse
}

export {
  checkAllIntegrations,
  connectIntegration,
  disconnectIntegration,
  handleOAuthResponse
}
